'use strict';

export default class GoogleRecaptcha {

	constructor (site_key = '6LfInlIUAAAAAH7Oo8cCjm522ij5y1ZnlvNCQ2V4') {
		this.source = 'https://www.google.com/recaptcha/api.js?onload=setGoogleRecaptcha&render=explicit';
		this.siteKey = site_key;
	}

	/**
	 * Load the Google reCaptcha library and will use the
	 * `target_element` to render the widget
	 * @param  {HTMLElement} target_element
	 * @return {undefined}
	 */
	get (target_element) {
		// Library is already loaded. Set the reCapcha
		if ('grecaptcha' in window) {
			this.set(target_element);
			return;
		}

		// Create
		const script = document.createElement('script');
		script.src = this.source;

		// Onload Callback
		window.setGoogleRecaptcha = function(target_element) {
			this.set(target_element);
		}.bind(this, target_element);

		// Append
		document.body.appendChild(script);
	}

	/**
	 * Will render the Google reCaptcha widget by
	 * determining if there is a child with the class of `.g-recaptcha`
	 * @param  {HTMLElement} element
	 * @return {undefined}
	 */
	set (element) {
		const recaptchaElement = element.querySelector('.g-recaptcha');
		let recaptchaId = recaptchaElement.dataset['g_recaptcha_id'];

		if (recaptchaElement === null) {
			console.error('Could not find a reCaptcha element for `' + element.classList.value + '`.');
			return;
		}

		// Reset reCaptcha
		if (typeof recaptchaId !== 'undefined') {
			window.grecaptcha.reset(recaptchaId);
			return;
		}

		// Render reCaptcha
		recaptchaId = window.grecaptcha.render(recaptchaElement, {
			sitekey: this.siteKey
		});

		// Set reCaptcha Id
		recaptchaElement.dataset['g_recaptcha_id'] = recaptchaId;
	}
}
